/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'cross-flow-support.back-to-all-products': '모든 제품으로 돌아가기',
  'cross-flow-support.close': '닫기',
  'cross-flow-support.product-store': '제품 스토어',
};
